export function addOrRemoveFromArray(array: string[], newValue: string) {
  return array.includes(newValue)
    ? array.filter(value => value !== newValue)
    : [...array, newValue];
}
